export default __webpack_public_path__ + "static/media/lp-sec06_ttl.d2f54e5d.png";